module.exports = __webpack_public_path__ + "static/withcuttriangle-7752a324e2a72300877022254d114b4b.gif";